define(
    'plugins/musicfavourite/model/item',['../util', 'exports'],
    function(util, /* exports */ Item) {

        'use strict';

        /**
         * Create a personalisation item for storage. Required properties
         * of an item are type, id, appId, title and postedTime.
         *
         * @param {object|string} props Object map with properties for new item.
         * @param {string=} appId AppID to use as default if not specified within props.
         */
        Item = function(props, appId) {
            var key, date;

            props = _parse(props, appId);

            for (key in props) {
                this[key] = this[key] || props[key];
            }

            this['class'] = this['class'] || 'bbc';
            this.title = this.title || this.id;

            date = isNaN(this.postedTime) ? new Date() : new Date(this.postedTime);
            this.postedTime = date.getTime();
        };


        Item.prototype = {

            equals: function(otherItem) {
                return otherItem && this.id === otherItem.id && this.type === otherItem.type && this.appId === otherItem.appId;
            },


            toJSON: function() {
                return {
                    'type':       this.type,
                    'id':         this.id,
                    'appId':      this.appId,
                    'title':      this.title,
                    'postedTime': this.postedTime
                };
            },

            toJSONString: function() {
                return util.json.stringify(this);
            },


            toURN: function() {
                var out = 'urn:' + this['class'] + ':' + encodeURIComponent(this.appId) + ':' + encodeURIComponent(this.type) + ':' + encodeURIComponent(this.id);
                if (this.title && this.title !== this.id) {
                    out += ':title=' + encodeURIComponent(this.title);
                }
                return out;
            },


            toString: function() {
                return 'Item[' + this.appId + '/@' + this.type + '/' + this.id + ']';
            },

            update: function(newTime) {
                newTime = newTime || new Date();

                if (newTime instanceof Date) { newTime = newTime.getTime(); }

                if (isNaN(newTime) && newTime > this.postedTime) {
                    this.postedTime = newTime;
                    return true;
                }

                return false;
            }
        };


        Item.ItemSyntaxError = function(args, propName, propValue) {

            this.name = 'Personalisation_ItemSyntaxError';
            this.given = args;
            this.message = 'Missing required property for an Item.';

            if (propName) {
                this.message = 'Invalid item property value for "' + propName + '", given: ' + propValue;
            }
        };
        Item.ItemSyntaxError.prototype = new Error();



        /**
         * Validates appId, type and id of an item specified as an object.
         */
        function _validateRequiredProp(input, propName) {
            var propValue = input[propName];

            if (!propValue || typeof(propValue) !== 'string') {
                throw new Item.ItemSyntaxError(input, propName, propValue);
            }

            return true;
        }


        var _parse = function(input, appId) {

            var inputType = typeof(input);

            if (inputType === 'object') {
                if (!input.appId && input.appid) {
                    input.appId = input.appid;
                    delete input.appid;
                }

                if (!input.appId) {
                    input.appId = appId;
                }

                _validateRequiredProp(input, 'appId') &&
                _validateRequiredProp(input, 'type') &&
                _validateRequiredProp(input, 'id');

                return input;

            } else if (inputType === 'string') {

                if (!_parse._regex) {
                    _parse._regex = /^urn:([^:]+):([^:]+):([^:]+):([^:]+)(?::title=([^:]+))?/;
                }

                var parsed = _parseWithRegex(input, _parse._regex);

                if (!parsed) { // now parse legacy syntax
                    if (!_parse._legacyRegex) {
                        _parse._legacyRegex = /^(?:(\w+):\/\/)?(?:\/([\w\.%+-]+)\/)?@?([\w\.%+-]+)\/([\w\.%+-]+)(?:\?title=([\w\.%+-]+))?/;
                    }

                    parsed = _parseWithRegex(input, _parse._legacyRegex);
                }

                if (parsed) {
                    return parsed;
                }
            }

            throw new Item.ItemSyntaxError(input);
        },

        _parseWithRegex = function(input, regex) {
            var out = {}, matches = regex.exec(input);

            if (matches) {
                out['class'] = decodeURIComponent(matches[1]); // TODO: parse non-bbc classes too

                if (out['class'] == 'bbc') {
                    if (matches[2]) {
                        out['appId'] = decodeURIComponent(matches[2]);
                    }

                    if (matches[3]) {
                        out['type'] = decodeURIComponent(matches[3]);
                    }

                    if (matches[4]) {
                        out['id'] = decodeURIComponent(matches[4]);
                    }

                    if (matches[5]) {
                        out['title'] = decodeURIComponent(matches[5]);
                    }
                }

                return _parse(out);
            }

            return false;
        };




        return Item;
    }
);

